const _1 = "1 1 0%"
const _auto = "1 1 auto"
const _initial = "0 1 auto"
const _none = "none"
const config = { "1": _1, "auto": _auto, "initial": _initial, "none": _none,  }
export { config as default, _1, _auto, _initial, _none }